import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import contentBlocksArticleListShowTrigger from '@coolblue-development/ga4-events/triggers/ContentBlocks/ArticleList/showTrigger';
import contentBlocksArticleListViewTrigger from '@coolblue-development/ga4-events/triggers/ContentBlocks/ArticleList/viewTrigger';
import contentBlocksTextImageShowTrigger from '@coolblue-development/ga4-events/triggers/ContentBlocks/TextImageVideo/showTrigger';
import contentBlocksTextImageViewTrigger from '@coolblue-development/ga4-events/triggers/ContentBlocks/TextImageVideo/viewTrigger';
import { TrackImmediate, TrackWhenVisible } from '@coolblue-development/next-analytics/client';
// TODO: Centralize these sub features to also use in src/components/Hemingway/Text/Text.tsx
export const articleListSubFeatures = ['one_list', 'two_lists', 'three_lists'];
export const textImageSubFeatures = [
    'text_and_image',
    'text_and_image_two_column',
    'text_and_image_three_column',
];
export const TrackingProvider = ({ columnCount, title, isArticleList, index, total_indices, correlation_id, children, }) => {
    const commonParams = {
        index,
        total_indices,
        correlation_id,
        title,
    };
    const articleListShowTriggerParams = {
        ...commonParams,
        sub_feature: articleListSubFeatures[columnCount - 1],
    };
    const articleListViewTriggerParams = {
        ...commonParams,
        sub_feature: articleListSubFeatures[columnCount - 1],
    };
    const textImageShowTriggerParams = {
        ...commonParams,
        sub_feature: textImageSubFeatures[columnCount - 1],
    };
    const textImageViewTriggerParams = {
        ...commonParams,
        sub_feature: textImageSubFeatures[columnCount - 1],
    };
    return isArticleList ? (_jsxs(_Fragment, { children: [_jsx(TrackImmediate, { trigger: contentBlocksArticleListShowTrigger(articleListShowTriggerParams) }), _jsx(TrackWhenVisible, { trigger: contentBlocksArticleListViewTrigger(articleListViewTriggerParams), children: children })] })) : (_jsxs(_Fragment, { children: [_jsx(TrackImmediate, { trigger: contentBlocksTextImageShowTrigger(textImageShowTriggerParams) }), _jsx(TrackWhenVisible, { trigger: contentBlocksTextImageViewTrigger(textImageViewTriggerParams), children: children })] }));
};
//# sourceMappingURL=TrackingProvider.js.map